"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormStatus = void 0;
var EFormStatus;
(function (EFormStatus) {
    EFormStatus["WAITING"] = "WAITING";
    EFormStatus["APROVED"] = "APROVED";
    EFormStatus["REJECTED"] = "REJECTED";
})(EFormStatus || (exports.EFormStatus = EFormStatus = {}));
